// src/pages/PoliticaTienda.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaFileContract, FaShieldAlt, FaCookieBite, FaStore, FaShippingFast, FaMoneyBillWave, FaExchangeAlt } from 'react-icons/fa';
import '../styles/LegalPages.css';

const PoliticaTienda = () => {
  return (
    <div className="legal-page">
      <div className="legal-energy-field">
        <div className="legal-energy-bolt"></div>
        <div className="legal-energy-bolt"></div>
        <div className="legal-energy-bolt"></div>
      </div>

      <div className="legal-container">
        <header className="legal-header">
          <h1>🛒 Políticas de Tienda</h1>
          <p className="legal-subtitle">
            Condiciones de compra, envíos y políticas comerciales de Reanimeitor
          </p>
        </header>

        <div className="legal-content">
          <div className="legal-section">
            <h2><FaStore /> Proceso de compra</h2>
            <p>
              Los pedidos se realizan directamente a través de la plataforma Reanimeitor. 
              El usuario puede seleccionar el producto, completar el proceso de compra y 
              realizar el pago desde el sitio web.
            </p>
          </div>

          <div className="legal-section">
            <h2><FaMoneyBillWave /> Precios</h2>
            <p>
              Todos los precios incluyen los impuestos aplicables. Reanimeitor se reserva 
              el derecho a modificar los precios sin previo aviso, aunque se respetará el 
              precio acordado en el momento de la confirmación del pedido.
            </p>
          </div>

          <div className="legal-section">
            <h2>💳 Formas de pago</h2>
            <p>
              El pago se realiza directamente a Reanimeitor mediante los métodos disponibles 
              en la plataforma (Bizum, transferencia bancaria u otros que se habiliten). 
              El pedido no se tramitará hasta que se confirme el pago.
            </p>
          </div>

          <div className="legal-section">
            <h2><FaShippingFast /> Envíos</h2>
            <p>
              El envío y la logística son gestionados por Miravia. Reanimeitor no realiza 
              envíos directamente. Una vez confirmado el pago, el pedido se tramita a través 
              de Miravia, quien se encarga del transporte, entrega y seguimiento.
            </p>
          </div>

          <div className="legal-section">
            <h2><FaExchangeAlt /> Devoluciones y reclamaciones</h2>
            <p>
              Las devoluciones, incidencias de transporte o reclamaciones relacionadas con 
              el envío deben gestionarse directamente con Miravia, de acuerdo con sus 
              condiciones. Reanimeitor no se responsabiliza de retrasos, pérdidas o daños 
              durante el transporte.
            </p>
          </div>

          <div className="legal-section">
            <h2>❌ Cancelaciones</h2>
            <p>
              Los pedidos pueden cancelarse antes de ser tramitados, siempre que no se haya 
              iniciado el proceso de envío. Para solicitar una cancelación, contacta con 
              nosotros lo antes posible.
            </p>
          </div>

          <div className="legal-section">
            <h2>📞 Contacto</h2>
            <p>
              Para cualquier duda previa o posterior a la compra, puedes escribirnos a 
              <strong> reanimeitor.energy@gmail.com</strong> o por WhatsApp al 
              <strong> 611 701 132</strong>.
            </p>
          </div>

          <Link to="/" className="legal-back-button">
            <FaArrowLeft /> Volver al Inicio
          </Link>

          <div className="legal-navigation">
            <Link to="/aviso-legal" className="legal-nav-button">
              <FaFileContract /> Aviso Legal
            </Link>
            <Link to="/politica-cookies" className="legal-nav-button">
              <FaCookieBite /> Cookies
            </Link>
            <Link to="/politica-privacidad" className="legal-nav-button">
              <FaShieldAlt /> Privacidad
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliticaTienda;